"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcAttachmentsList = class UcAttachmentsList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parent_id;
    onParent_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent_id");
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    container;
    async $$load_container() {
        return this.$fn.fetch('list_attachment', { parameters: { 'owner-id': this.parent_id || this.parent.id }, asResourceContainer: true });
    }
    ux;
    dataMembers = ['container', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                container: null,
                ux: null,
            },
        };
    }
    get items() {
        if (this.loaded) {
            return this.container.data;
        }
        return null;
    }
    get isReadOnly() {
        if (this.loaded) {
            return this.readonly || (this.parent && this.parent.isReadOnly);
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_2570_getActionArgs($event) {
        return {
            name: "WAttachmentModal",
            props: {
                object_id: this.parent_id || this.parent.id,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8513850661379123_showModal_2574_getActionArgs($event) {
        return {
            name: "WAttachmentModal",
            props: {
                object_id: this.parent_id || this.parent.id,
                attachment: _.cloneDeep($event.scope.item),
            },
        };
    }
    async evh_8513850661379123_clickPreventStop(event, scope) {
        return await this.actions.evh_8513850661379123_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3861238174616472_request_2578_getActionArgs($event) {
        return {
            operation: "delete_attachment",
            data: $event.scope.item,
        };
    }
    async act_3861238174616472_request_2578_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_3861238174616472_clickPreventStop(event, scope) {
        return await this.actions.evh_3861238174616472_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2568 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2567 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2568,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2567],
        });
        const act_8320016629450276_reloadComponentData_2572 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8320016629450276_close_2571 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_2572,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_8320016629450276_showModal_2570 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_2570_getActionArgs,
            events: [evh_8320016629450276_close_2571],
        });
        const evh_8320016629450276_clickPreventStop_2569 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_2570,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_2569],
        });
        const act_8513850661379123_reloadComponentData_2576 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8513850661379123_close_2575 = new core_1.actions.EventHandlerImpl({
            action: act_8513850661379123_reloadComponentData_2576,
            event: "close",
            displayName: "reloadComponentData",
        });
        const act_8513850661379123_showModal_2574 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8513850661379123_showModal_2574_getActionArgs,
            events: [evh_8513850661379123_close_2575],
        });
        const evh_8513850661379123_clickPreventStop_2573 = new core_1.actions.EventHandlerImpl({
            action: act_8513850661379123_showModal_2574,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8513850661379123_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8513850661379123_clickPreventStop_2573],
        });
        const act_3861238174616472_reloadComponentData_2580 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_3861238174616472_success_2579 = new core_1.actions.EventHandlerImpl({
            action: act_3861238174616472_reloadComponentData_2580,
            event: "success",
            displayName: "reloadComponentData",
        });
        const act_3861238174616472_request_2578 = new core_1.actions.RequestAction({
            actionArgs: this.act_3861238174616472_request_2578_getActionArgs,
            confirm: this.act_3861238174616472_request_2578_getConfirm,
            events: [evh_3861238174616472_success_2579],
        });
        const evh_3861238174616472_clickPreventStop_2577 = new core_1.actions.EventHandlerImpl({
            action: act_3861238174616472_request_2578,
            event: "click.prevent.stop",
            displayName: "request",
        });
        const evh_3861238174616472_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3861238174616472_clickPreventStop_2577],
        });
        return {
            act_7315092382398562_reloadComponentData_2568,
            evh_7315092382398562_reload_2567,
            evh_7315092382398562_reload,
            act_8320016629450276_reloadComponentData_2572,
            evh_8320016629450276_close_2571,
            act_8320016629450276_showModal_2570,
            evh_8320016629450276_clickPreventStop_2569,
            evh_8320016629450276_clickPreventStop,
            act_8513850661379123_reloadComponentData_2576,
            evh_8513850661379123_close_2575,
            act_8513850661379123_showModal_2574,
            evh_8513850661379123_clickPreventStop_2573,
            evh_8513850661379123_clickPreventStop,
            act_3861238174616472_reloadComponentData_2580,
            evh_3861238174616472_success_2579,
            act_3861238174616472_request_2578,
            evh_3861238174616472_clickPreventStop_2577,
            evh_3861238174616472_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcAttachmentsList.prototype, "parent_id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent_id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsList.prototype, "onParent_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcAttachmentsList.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsList.prototype, "onParent", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcAttachmentsList.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAttachmentsList.prototype, "onReadonly", null);
UcAttachmentsList = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcAttachmentsList);
exports.default = UcAttachmentsList;
vue_property_decorator_1.Vue.component("UcAttachmentsList", UcAttachmentsList);
